/// <amd-module name="typeahead/features/NonMobileTakeOver" />

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import {SuggestionSelectedMessage} from "typeahead/core/message/SuggestionSelectedMessage";
import {SuggestionShownMessage} from "typeahead/core/message/SuggestionShownMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {UserExitedMessage} from "typeahead/core/message/UserExitedMessage";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IInputElementFocusByHumanOrScriptHandler} from
    "typeahead/core/presentation/IInputElementFocusByHumanOrScriptHandler";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

const configuration: IStripingConfiguration[] = [
    {
        experiment: {
            id: 25632,
            name: "ess_non_mobile_typeahead_takeover_experience_hotel",
        },
        tabs: ["hotel"],
    },
    {
        experiment: {
            id: 25633,
            name: "ess_non_mobile_typeahead_takeover_experience_flights",
        },
        tabs: ["flight"],
    },
    {
        experiment: {
            id: 25634,
            name: "ess non mobile typeahead takeover experience cars",
        },
        tabs: ["car"],
    },
    {
        experiment: {
            id: 25635,
            name: "ess_non_mobile_typeahead_takeover_experience_packages",
        },
        tabs: ["package", "packageFlightHotel", "packageFlightHotelCar",
            "packageFlightCar", "packageHotelCar", "flightHotel", "flightHotelCar", "flightCar",
            "hotelCar", "carHotel", "carHotelFlight", "carFlight"],
    },
];

const variant2Configuration: IStripingConfiguration[] = [
    {
        experiment: {
            id: 25632,
            name: "ess_non_mobile_typeahead_takeover_experience_hotel",
            value: 2,
        },
        tabs: ["hotel"],
    },
    {
        experiment: {
            id: 25633,
            name: "ess_non_mobile_typeahead_takeover_experience_flights",
            value: 2,
        },
        tabs: ["flight"],
    },
    {
        experiment: {
            id: 25634,
            name: "ess non mobile typeahead takeover experience cars",
            value: 2,
        },
        tabs: ["car"],
    },
    {
        experiment: {
            id: 25635,
            name: "ess_non_mobile_typeahead_takeover_experience_packages",
            value: 2,
        },
        tabs: ["package", "packageFlightHotel", "packageFlightHotelCar",
            "packageFlightCar", "packageHotelCar", "flightHotel", "flightHotelCar", "flightCar",
            "hotelCar", "carHotel", "carHotelFlight", "carFlight"],
    },
];

const allConfigs = [configuration, variant2Configuration];

const css: string = `
        .typeahead-non-mobile-overlay {
            background: #000000 !important;
            margin-left: -50%;
            width: 150%;
            opacity: 0.6 !important;
        }
        
        .typeahead-non-mobile-overlay-zIndex {
            z-index: 1000 !important;
        }
        
        .typeahead-non-mobile-overlay-input, .typeahead-non-mobile-overlay-input:focus {
            border: none !important;
            box-shadow: none !important;
            -webkit-box-shadow: none !important;
            border-radius: 0 !important;
        }
        
        .typeahead-non-mobile-overlay-autocomplete-parent  .autocomplete-dropdown {
            border: none !important;
            border-radius: 0 !important;
            top: 40px;
        }
        
        .typeahead-non-mobile-overlay-autocomplete-parent .autocomplete-arrow::after {
            display: none !important;
        }
    `;

export class NonMobileTakeOver implements
    IExperimentalFeature, IInputElementFocusByHumanOrScriptHandler, IPageLoadHandler {

    private static shouldEnableNonMobileTakeOver(context: IContext): boolean {
        return !TypeaheadUtils.isWithinMobileBreakpoint() && ExecutionHelper.shouldExecute(context, configuration);
    }
    private static getMercuryWzdTab(): string {
        return $("li.tab:visible").children("button.on").data("lob");
    }

    private static removeCloseTypeaheadLink($typeaheadParentContainer: JQuery): void {
        let isEsshelperEnabled = $($typeaheadParentContainer).children()
            .find(".autocomplete-dropdown").children()
            .find("a.feedback").css("display") === "block";

        // Only remove close link if essHelper is enabled
        if (isEsshelperEnabled) {
            $($typeaheadParentContainer).children()
                .find(".autocomplete-dropdown").find("a.close").remove();
            $($typeaheadParentContainer).children()
                .find(".autocomplete-dropdown").find("footer")
                .css("backgroundColor", "#ffffff");
        } else {
            $($typeaheadParentContainer).children()
                .find(".autocomplete-dropdown").find("footer").remove();
            $($typeaheadParentContainer).children()
                .find(".autocomplete-dropdown").css("paddingBottom", "1em");
        }
    }

    private static addNonMobileOverlayParentClass($typeaheadParentContainer: JQuery): void {
        $($typeaheadParentContainer).addClass("typeahead-non-mobile-overlay-autocomplete-parent");
    }

    private static addNonMobileModalBackground($typeaheadParentContainer: JQuery): void {
        let modalBgHtml: string =
            `<div class="typeahead-non-mobile-overlay modal-background modal-dismiss active"></div>`;
        let taModalExists = $("div.typeahead-non-mobile-overlay").length > 0;

        if (!taModalExists) {
            $($typeaheadParentContainer).prepend(modalBgHtml);
        }
    }

    private static indentTypeaheadResultsWithIcon($typeaheadParentContainer: JQuery): void {
        $($typeaheadParentContainer).children()
            .find(".autocomplete-dropdown").find("ul.results").children()
            .find("li.results-item").css("padding", "0 0.92307692em 0 0.12307692em");
    }

    private static indentypeaheadResultsWithoutIcon($typeaheadParentContainer: JQuery): void {
        $($typeaheadParentContainer).children()
            .find(".autocomplete-dropdown").find("ul.results").children()
            .find("li.results-item").css("padding", "0 0.92307692em 0 1.92307692em");
    }

    private static removeNonMobileModalBackground($typeaheadParentContainer: JQuery): void {
        $("div.typeahead-non-mobile-overlay").remove();
    }

    private static setNonMobileOverlayZIndex($typeaheadParentContainer: JQuery): void {
        let $typeaheadInputContainer: JQuery =
            $($typeaheadParentContainer).children().find("div.input-btn-group");
        $($typeaheadInputContainer).addClass("typeahead-non-mobile-overlay-zIndex");
    }

    private static resetNonMobileOverlayZIndex($typeaheadParentContainer: JQuery): void {
        $($typeaheadParentContainer).children()
            .find("div.input-btn-group").removeClass("typeahead-non-mobile-overlay-zIndex");
    }

    private static handleInputStyles(context: IContext): void {
        if (NonMobileTakeOver.shouldEnableNonMobileTakeOver(context)) {
            NonMobileTakeOver.removeInputBorders();
            NonMobileTakeOver.modifyInputPlaceholderIcon();
        }
    }

    private static removeInputBorders(): void {
        $("input[aria-owns='typeaheadDataPlain']:visible")
            .addClass("typeahead-non-mobile-overlay-input");
    }

    private static modifyInputPlaceholderIcon(): void {
        let iconHtml: string = `
                    <svg class="uitk-icon-svg">
                        <use xlink:href="#uitk-icon-search"/>
                    </svg>
        `;
        let $spanIcon: JQuery =
            $("input[aria-owns='typeaheadDataPlain']:visible").parent().find("span.icon");

        $spanIcon.children().remove();
        $spanIcon.append(iconHtml);
    }

    private static openOverlay($input: JQuery): void {
        let $typeaheadParentContainer: JQuery = $($input).closest("div.col");
        NonMobileTakeOver.addNonMobileOverlayParentClass($typeaheadParentContainer);
        NonMobileTakeOver.addNonMobileModalBackground($typeaheadParentContainer);
        NonMobileTakeOver.setNonMobileOverlayZIndex($typeaheadParentContainer);
    }

    private static removeNonMobileOverlay(inputElemId: string): void {
        let $inputElem = $("#" + inputElemId);
        let $typeaheadParentContainer: JQuery = $($inputElem).closest("div.col");
        NonMobileTakeOver.removeNonMobileModalBackground($typeaheadParentContainer);
        NonMobileTakeOver.resetNonMobileOverlayZIndex($typeaheadParentContainer);
        $inputElem
            .off("mousedown.nonmobiletakeover keydown.nonmobiletakeover keyup.nonmobiletakeover");
    }

    private static handleSuggestionSelection(topic: string,
                                             message: SuggestionSelectedMessage, context: IContext): void {
        if (NonMobileTakeOver.shouldEnableNonMobileTakeOver(context)) {
            NonMobileTakeOver.removeNonMobileOverlay(message.getDomElementId());
        }
    }

    private static handleUserExit(topic: string, message: UserExitedMessage, context: IContext): void {
        if (NonMobileTakeOver.shouldEnableNonMobileTakeOver(context)) {
            NonMobileTakeOver.removeNonMobileOverlay(message.getDomElementId());
        }
    }

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments([].concat.apply([], allConfigs));
    }

    public handlePageLoad(options: any, context: IContext): void {
        let style = document.createElement("style");
        style.type = "text/css";
        style.innerHTML = css;
        document.head.appendChild(style);

        context.tab = NonMobileTakeOver.getMercuryWzdTab();

        ExecutionHelper.abTest.getBucketingPromise().done(() => {

            // Ensures styles are applied to input at page load if config is executed
            NonMobileTakeOver.handleInputStyles(context);

            uitk.subscribe("sfSelectedLobs.updated", (topic: string, data: any) => {
                context.tab = data.searchType;
                NonMobileTakeOver.handleInputStyles(context);
            });

            TypeaheadMessage.subscribe(SuggestionSelectedMessage.getTopic(),
                (topic: string, message: SuggestionSelectedMessage) => {
                    NonMobileTakeOver.handleSuggestionSelection(topic, message, context);
                });

            TypeaheadMessage.subscribe(UserExitedMessage.getTopic(),
                (topic: string, message: UserExitedMessage) => {
                    NonMobileTakeOver.handleUserExit(topic, message, context);
                });

        });

    }

    public handleInputElementFocusByHumanOrScript($inputElem: JQuery, context: IContext): void {
        if (NonMobileTakeOver.shouldEnableNonMobileTakeOver(context)) {
            let $typeaheadParentContainer: JQuery = $($inputElem).closest("div.col");

            context.tab = NonMobileTakeOver.getMercuryWzdTab();

            // Common behavior in both variants
            if (ExecutionHelper.shouldExecute(context, configuration)) {
                // Open the overlay
                NonMobileTakeOver.openOverlay($inputElem);

                let topValue: number = $($inputElem).closest(".input-btn-group").height() - 8;
                $(".typeahead-non-mobile-overlay-autocomplete-parent  .autocomplete-dropdown")
                    .css("top", topValue + "px");

                // Hide ja_JP typeahead
                $("div.dropdown-con").css("display", "none");

                $inputElem.on("mousedown.nonmobiletakeover keydown.nonmobiletakeover keyup.nonmobiletakeover",
                    () => {
                        $("div.dropdown-con").css("display", "none");
                    });
            }

            TypeaheadMessage.subscribe(SuggestionShownMessage.getTopic(),
                (topic: string, message: SuggestionShownMessage) => {

                    // Handle the indenation of results per tab irrespectove of variant
                    if (ExecutionHelper.shouldExecute(context, configuration)) {
                        if (NonMobileTakeOver.getMercuryWzdTab() !== "flight") {
                            NonMobileTakeOver.indentTypeaheadResultsWithIcon($typeaheadParentContainer);
                        } else {
                            NonMobileTakeOver.indentypeaheadResultsWithoutIcon($typeaheadParentContainer);
                        }
                    }

                    // Removal of typeahead close link should only happen for variant2
                    if (ExecutionHelper.shouldExecute(context, variant2Configuration)) {

                        NonMobileTakeOver.removeCloseTypeaheadLink($typeaheadParentContainer);
                    }
                });
        }
    }
}
